import { Injectable, inject } from '@angular/core';
import { shouldSkip, SkipInteraction, StoreService } from '@shared/store';

@Injectable({
  providedIn: 'root',
})
export class FaceCheckService {
  private readonly store = inject(StoreService);

  private hasConsented: boolean;

  constructor() {
    this.hasConsented = this.store.select(shouldSkip(SkipInteraction.CameraConsentPage));
  }

  public rememberConsent(): void {
    this.hasConsented = true;
  }

  public hasAlreadyConsented(): boolean {
    return this.hasConsented;
  }
}
